module.exports = __webpack_public_path__ + "media/images/fire-d1ff07cd14ad326021d143b751f68725.svg";